module.exports = __webpack_public_path__ + "assets/img/zixun01.db9a10ca.png";